import { baseUrl } from '@/consts/route';
import { UpdateUserDto, User } from '@/types/user';

export type LoginResponse = {
  accessToken: string;
  accessTokenExpiresIn: number;
  refreshTokenExpiresIn: number;
  user: User;
};

export const login = async (email: string, password: string, rememberMe?: string) => {
  return await fetch(`${baseUrl}/auth/sign-in`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      password,
      rememberMe: rememberMe === 'true' ? true : false,
    }),
  });
};

type VerifyEmailMethod = 'register' | 'reset';

export const verifyEmail = async (email: string, method: VerifyEmailMethod = 'register') => {
  return await fetch(`${baseUrl}/auth/verify/email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, method }),
  });
};

export const verifyCode = async (email: string, code: string) => {
  return await fetch(`${baseUrl}/auth/verify/code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });
};

export const signUp = async (body: {
  email?: string;
  password?: string;
  register_token?: string;
  phone_number: string;
  is_advertise_term_agree?: boolean;
  privacy_term_agree_date?: Date;
  service_term_agree_date?: Date;
  advertise_term_agree_date?: Date;
  referral_code?: string;
  business_number?: string;
  display_name?: string;
}) => {
  return await fetch(`${baseUrl}/auth/sign-up`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
};

export const signUpDirect = async (body: {
  email?: string;
  password?: string;
  phone_number: string;
  is_advertise_term_agree?: boolean;
  privacy_term_agree_date?: Date;
  service_term_agree_date?: Date;
  advertise_term_agree_date?: Date;
  referral_code: string;
  business_number?: string;
  display_name?: string;
}) => {
  return await fetch(`${baseUrl}/auth/sign-up/direct`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
};

export const resetPassword = async ({
  email,
  code,
  password,
}: {
  email: string;
  code: number;
  password: string;
}) => {
  return await fetch(`${baseUrl}/auth/reset/password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code, password }),
  });
};

export const updateUser = async ({
  accessToken,
  body,
}: {
  accessToken: string;
  body: UpdateUserDto;
}) => {
  return await fetch(`${baseUrl}/user/me`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });
};

export const updateUserDirect = async ({
  accessToken,
  body,
}: {
  accessToken: string;
  body: UpdateUserDto;
}) => {
  return await fetch(`${baseUrl}/user/me/direct`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });
};

export const getUserMe = async (accessToken: string): Promise<User> => {
  const res = await fetch(`${baseUrl}/user/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return await res.json();
};
